import FilterBeachType from './FilterBeachType';

export default FilterBeachType;
